<template>
  <section id="dataguru">
    <div class="container-1056">
      <div class="card py-16 px-16 mt-16">
        <h4 class="title is-5 text-center">{{ actionTitle }} Data Guru</h4>
        <div class="rows">
          <div class="row">
            <div class="columns">
              <div class="column">
                <b-field
                  horizontal
                  label="Nama Guru"
                  :type="form.nama_guru.type"
                  :message="form.nama_guru.message"
                >
                  <b-input
                    name="nama_guru"
                    placeholder="Nama Guru"
                    @input="clearError(form.nama_guru)"
                    v-model="form.nama_guru.value"
                    expanded
                  ></b-input>
                </b-field>
                <b-field
                  horizontal
                  label="NUPTK/No Guru"
                  :type="form.nuptk.type"
                  :message="form.nuptk.message"
                >
                  <b-input
                    name="nuptk"
                    placeholder="NUPTK Guru"
                    @input="clearError(form.nuptk)"
                    v-model="form.nuptk.value"
                    expanded
                  ></b-input>
                </b-field>
                <b-field
                  horizontal
                  label="Tanggal Lahir"
                  :type="form.tgl_lahir.type"
                  :message="form.tgl_lahir.message"
                >
                  <b-datepicker
                    ref="datepicker"
                    :max-date="new Date()"
                    v-model="form.tgl_lahir.value"
                    placeholder="Select a date"
                  >
                    <b-button
                      label="Clear"
                      type="is-danger"
                      icon-left="close"
                      outlined
                      @click="form.tgl_lahir.value = ''"
                    />
                  </b-datepicker>
                  <b-button
                    @click="$refs.datepicker.toggle()"
                    icon-left="calendar-today"
                    type="is-primary"
                  >
                  </b-button>
                </b-field>
                <b-field
                  horizontal
                  label="Jenis Kelamin"
                  :type="form.jenis_kelamin.type"
                  :message="form.jenis_kelamin.message"
                >
                  <b-select
                    @input="clearError(form.jenis_kelamin)"
                    v-model="form.jenis_kelamin.value"
                    placeholder="Select one"
                    expanded
                  >
                    <option value="Laki-Laki">Laki-Laki</option>
                    <option value="Perempuan">Perempuan</option>
                  </b-select>
                </b-field>
                <b-field
                  label="No HP/WA"
                  horizontal
                  :type="form.no_handphone.type"
                  :message="form.no_handphone.message"
                >
                  <div class="columns">
                    <div class="column is-2">
                      <b-button label="+62" type="is-light" disabled>
                      </b-button>
                    </div>
                    <div class="column">
                      <b-input
                        name="no_handphone"
                        placeholder="No Handphone/WA"
                        @input="clearError(form.no_handphone)"
                        v-model="form.no_handphone.value"
                        expanded
                      >
                      </b-input>
                    </div>
                  </div>
                </b-field>
                <b-field
                  horizontal
                  label="Email"
                  :type="form.email.type"
                  :message="form.email.message"
                >
                  <b-input
                    name="email"
                    placeholder="Email"
                    @input="clearError(form.email)"
                    v-model="form.email.value"
                    expanded
                  ></b-input>
                </b-field>
                <b-field
                  horizontal
                  label="Jenis Paket"
                  :type="form.jenis_paket.type"
                  :message="form.jenis_paket.message">
                  <div class="rows">
                    <div class="row">
                      <b-checkbox v-model="form.jenis_paket.value" native-value="CT-1">Computational Thinking 1</b-checkbox>
                    </div>
                    <div class="row">
                      <b-checkbox v-model="form.jenis_paket.value" native-value="CT-2">Computational Thinking 2</b-checkbox>
                    </div>
                    <div class="row">
                      <b-checkbox v-model="form.jenis_paket.value" native-value="CT-Advanced">
                        Computational Thinking Advanced
                      </b-checkbox>
                    </div>
                    <div class="row">
                      <b-checkbox v-model="form.jenis_paket.value" native-value="INF">Informatika</b-checkbox>
                    </div>
                  </div>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  horizontal
                  label="Mata Pelajaran"
                  :type="form.mata_pelajaran.type"
                  :message="form.mata_pelajaran.message"
                >
                  <b-input
                    name="mata_pelajaran"
                    placeholder="Mata Pelajaran"
                    @input="clearError(form.mata_pelajaran)"
                    v-model="form.mata_pelajaran.value"
                    expanded
                  ></b-input>
                </b-field>
                <b-field
                  horizontal
                  label="Jabatan"
                  :type="form.jabatan.type"
                  :message="form.jabatan.message"
                >
                  <b-input
                    name="jabatan"
                    placeholder="Jabatan"
                    @input="clearError(form.jabatan)"
                    v-model="form.jabatan.value"
                    expanded
                  ></b-input>
                </b-field>
                <b-field
                  horizontal
                  label="Asal Sekolah"
                  :type="form.nama_sekolah.type"
                  :message="form.nama_sekolah.message"
                >
                  <b-select
                    v-model="form.nama_sekolah.value"
                    @input="clearError(form.nama_sekolah)"
                    placeholder="Select one"
                    expanded
                  >
                    <option
                      v-for="item in sekolahs"
                      :key="item.id_sekolah"
                      :value="item.id_sekolah"
                    >
                      {{ item.nama_sekolah }}
                    </option>
                  </b-select>
                </b-field>
                <b-field
                  horizontal
                  label="Nomor Paket"
                  :type="form.nomor_paket.type"
                  :message="form.nomor_paket.message"
                  v-model="form.nomor_paket.value"
                >
                  <b-numberinput
                    v-model="form.nomor_paket.value"
                    @input="clearError(form.nomor_paket)"
                    min="0"
                  ></b-numberinput>
                </b-field>
                <b-field
                  horizontal
                  label="Nomor Urut Sertifikat"
                  :type="form.nomor_urut.type"
                  :message="form.nomor_urut.message"
                  v-model="form.nomor_urut.value"
                >
                  <b-numberinput
                    v-model="form.nomor_urut.value"
                    @input="clearError(form.nomor_urut)"
                    min="0"
                  ></b-numberinput>
                </b-field>
                <!-- <p style="font-weight: bold">Pilih Paket</p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="rows mt-24">
          <div class="row">
            <div class="columns">
              <div class="column">
                <b-button
                  class="button is-danger btn-block"
                  tag="router-link"
                  to="/biro/berandaguru"
                >
                  Kembali
                </b-button>
              </div>
              <div class="column">
                <button class="button is-success btn-block" @click="confirm()">
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="box">
          Pilih Paket Guru
          <b-field>
            <b-checkbox>Basic</b-checkbox>
        </b-field>
        <b-field>
            <b-checkbox>Basic</b-checkbox>
        </b-field>
        <b-field>
            <b-checkbox>Basic</b-checkbox>
        </b-field>
        </div> -->
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    >
    </b-loading>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      actionTitle: "",
      editID: 0,
      detailId: "",
      activeBiro: Object,
      dataGuru: new FormData(),
      editDataGuru: {},
      form: {
        nama_guru: { value: "", type: "", message: "" },
        nuptk: { value: "", type: "", message: "" },
        jenis_kelamin: { value: "", type: "", message: "" },
        tgl_lahir: { value: "", type: "", message: "" },
        no_handphone: { value: "", type: "", message: "" },
        email: { value: "", type: "", message: "" },
        jenis_paket: { value: [], type: "", message: "" },
        mata_pelajaran: { value: "", type: "", message: "" },
        jenis_guru: { value: "", type: "", message: "" },
        nama_sekolah: { value: "", type: "", message: "" },
        nama_regu: { value: "", type: "", message: "" },
        nomor_paket: { value: "", type: "", message: "" },
        jabatan: { value: "", type: "", message: "" },
        nomor_urut: { value: "", type: "", message: "" },
      },
      snackbarMesssage: "",
      sekolahs: [],
      regus: [],
      config: {},
    };
  },
  methods: {
    getSekolahByBiro() {
      var uri = this.$apiUrl + "sekolah/biro/" + this.detailId;
      this.$http.get(uri, this.config).then((response) => {
        this.sekolahs = response.data.value;
      });
    },
    getRegu() {
      var uri = this.$apiUrl + "regu";
      this.$http.get(uri, this.config).then((response) => {
        this.regus = response.data.value;
      });
    },
    getData(editID) {
      var uri = this.$apiUrl + "guru/" + editID;

      this.$http.get(uri, this.config).then((response) => {
        this.editDataGuru = response.data.value;
        this.formEdit(this.editDataGuru);
      });
    },
    formEdit(dataGuru) {
      console.log(dataGuru);
      this.form.nuptk.value = dataGuru.nuptk;
      this.form.nama_guru.value = dataGuru.nama_guru;
      this.form.jenis_kelamin.value = dataGuru.jenis_kelamin;
      if (dataGuru.tgl_lahir !== null) {
        this.form.tgl_lahir.value = new Date(dataGuru.tgl_lahir);
      }
      this.form.no_handphone.value = dataGuru.no_handphone;
      this.form.email.value = dataGuru.email;
      this.form.jenis_paket.value = dataGuru.jenis_paket;
      this.form.mata_pelajaran.value = dataGuru.mata_pelajaran;
      this.form.jenis_guru.value = dataGuru.jenis_guru;
      this.form.nama_sekolah.value = dataGuru.id_sekolah;
      this.form.nama_regu.value = dataGuru.id_regu;
      this.form.nomor_paket.value = dataGuru.nomor_paket;
      this.form.jabatan.value = dataGuru.jabatan;
      this.form.nomor_urut.value = dataGuru.nomor_urut;
    },
    convertTgl(tglLahir) {
      var formDate = tglLahir;
      var year = formDate.getFullYear();
      var month = formDate.getMonth() + 1;
      var date = formDate.getDate();

      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;

      var fixedDate = year + "-" + month + "-" + date;

      return fixedDate;
    },
    clearError(form) {
      console.log(form);
      form.type = "";
      form.message = "";
    },
    checkData() {
      let count = 0;
      let regexHP = new RegExp(/^\d+$/);
      let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

      if (this.form.nuptk.value === "") {
        this.form.nuptk.type = "is-danger";
        this.form.nuptk.message = "NUPTK harus di isi";
        count++;
      }
      if (this.form.nama_guru.value === "") {
        this.form.nama_guru.type = "is-danger";
        this.form.nama_guru.message = "Nama harus diisi";
        count++;
      }
      if (this.form.jenis_kelamin.value === "") {
        this.form.jenis_kelamin.type = "is-danger";
        this.form.jenis_kelamin.message = "Jenis Kelamin harus diisi";
        count++;
      }
      // if(this.form.tgl_lahir.value ==="")
      // {
      //     this.form.tgl_lahir.type = 'is-danger'
      //     this.form.tgl_lahir.message ="Tanggal harus diisi "
      //     count ++
      // }
      if (this.form.no_handphone.value === "") {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message = "No Handphone harus diisi";
        count++;
      } else if (!regexHP.test(this.form.no_handphone.value)) {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message =
          "No hanphone diisi tanpa spasi dan karakter";
        count++;
      } else if (
        this.form.no_handphone.value.length < 9 ||
        this.form.no_handphone.value.length > 13
      ) {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message = "Panjang No Handphone 9 - 13 digit";
        count++;
      }
      if (this.form.email.value === "") {
        this.form.email.type = "is-danger";
        this.form.email.message = "Email harus Diisi";
        count++;
      } else if (!regexEmail.test(this.form.email.value)) {
        this.form.email.type = "is-danger";
        this.form.email.message = "Email harus valid";
        count++;
      }
      if (!this.form.jenis_paket.value.length) {
        this.form.jenis_paket.type = "is-danger";
        this.form.jenis_paket.message = "Jenis Paket Harus diisi sesuai";
        count++;
      }
      if (this.form.mata_pelajaran.value === "") {
        this.form.mata_pelajaran.type = "is-danger";
        this.form.mata_pelajaran.message = "Mata Pelajaran Harus diisi sesuai";
        count++;
      }
      if (this.form.nama_sekolah.value === "") {
        this.form.nama_sekolah.type = "is-danger";
        this.form.nama_sekolah.message = "Sekolah Harus diisi";
        count++;
      }
      if (this.form.jabatan.value === "") {
        this.form.jabatan.type = "is-danger";
        this.form.jabatan.message = "Jabatan Harus diisi";
        count++;
      }
      if (this.form.nomor_paket.value === "") {
        this.form.nomor_paket.type = "is-danger";
        this.form.nomor_paket.message = "Nomor Paket Harus diisi";
        count++;
      }
      if (this.form.nomor_urut.value === "") {
        this.form.nomor_urut.type = "is-danger";
        this.form.nomor_urut.message = "Nomor Urut Harus diisi";
        count++;
      }
      // if(this.form.nomor_paket.value === 0)
      // {
      //     this.form.nomor_paket.type ='is-danger'
      //     this.form.nomor_paket.message =" Nomor Paket Harus diisi"
      //     count ++
      // }

      if (count > 0) return false;
    },

    checkDataUbah() {
      let count = 0;
      let regexHP = new RegExp(/^\d+$/);
      let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
      // let regexEmail = new RegExp(/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/)

      // let regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (this.form.nuptk.value === null) {
        this.form.nuptk.type = "is-danger";
        this.form.nuptk.message = "NUPTK harus di isi";
        count++;
      }
      if (this.form.nama_guru.value === "") {
        this.form.nama_guru.type = "is-danger";
        this.form.nama_guru.message = "Nama harus diisi";
        count++;
      }
      if (this.form.jenis_kelamin.value === null) {
        this.form.jenis_kelamin.type = "is-danger";
        this.form.jenis_kelamin.message = "Jenis Kelamin harus diisi";
        count++;
      }
      // if(this.form.tgl_lahir.value ==="")
      // {
      //     this.form.tgl_lahir.type = 'is-danger'
      //     this.form.tgl_lahir.message ="Tanggal harus diisi "
      //     count ++
      // }
      if (this.form.no_handphone.value === null) {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message = "No Handphone harus diisi";
        count++;
      } else if (!regexHP.test(this.form.no_handphone.value)) {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message =
          "No hanphone diisi tanpa spasi dan karakter";
        count++;
      } else if (
        this.form.no_handphone.value.length < 10 ||
        this.form.no_handphone.value.length > 13
      ) {
        this.form.no_handphone.type = "is-danger";
        this.form.no_handphone.message = "Panjang No Handphone 10 - 13 ";
        count++;
      }
      if (this.form.email.value === "") {
        this.form.email.type = "is-danger";
        this.form.email.message = "Email harus Diisi";
        count++;
      } else if (!regexEmail.test(this.form.email.value)) {
        this.form.email.type = "is-danger";
        this.form.email.message = "Email harus valid";
        count++;
      }
      if (this.form.jenis_paket.value === null) {
        this.form.jenis_paket.type = "is-danger";
        this.form.jenis_paket.message = "Jenis Paket Harus diisi sesuai";
        count++;
      }
      if (this.form.mata_pelajaran.value === null) {
        this.form.mata_pelajaran.type = "is-danger";
        this.form.mata_pelajaran.message = "Mata Pelajaran Harus diisi sesuai";
        count++;
      }
      if (this.form.nama_sekolah.value === "") {
        this.form.nama_sekolah.type = "is-danger";
        this.form.nama_sekolah.message = "Sekolah Harus diisi";
        count++;
      }
      if (this.form.jabatan.value === "") {
        this.form.jabatan.type = "is-danger";
        this.form.jabatan.message = "Jabatan Harus diisi";
        count++;
      }
      if (this.form.nomor_paket.value === "") {
        this.form.nomor_paket.type = "is-danger";
        this.form.nomor_paket.message = "Nomor Paket Harus diisi";
        count++;
      }
      if (this.form.nomor_urut.value === "") {
        this.form.nomor_urut.type = "is-danger";
        this.form.nomor_urut.message = "Nomor Urut Harus diisi";
        count++;
      }

      if (count > 0) return false;
    },
    tambahData() {
      this.isLoading = true;
      if (this.checkData() == false) {
        this.snackbar("Gagal...Silahkan input lagi", "is-danger");
        this.isLoading = false;
      } else {
        let dataGuru = {
          nuptk: this.form.nuptk.value,
          nama_guru: this.form.nama_guru.value,
          jenis_kelamin: this.form.jenis_kelamin.value,
          tgl_lahir: this.form.tgl_lahir.value !== "" ? this.convertTgl(this.form.tgl_lahir.value) : this.form.tgl_lahir.value,
          no_handphone: this.form.no_handphone.value,
          email: this.form.email.value,
          jenis_paket: this.form.jenis_paket.value,
          mata_pelajaran: this.form.mata_pelajaran.value,
          jenis_guru: this.form.jenis_guru.value,
          id_sekolah: this.form.nama_sekolah.value,
          id_regu: this.form.nama_regu.value,
          nomor_paket: this.form.nomor_paket.value,
          nomor_urut: this.form.nomor_urut.value,
          jabatan: this.form.jabatan.value, 
        }

        var uri = this.$apiUrl + "guru";
        this.$http
          .post(uri, dataGuru, this.config)
          .then((response) => {
            this.isLoading = false;
            this.$router.push({ name: "BerandaGuru" });
            this.snackbarMessage = response.data.message;
            this.snackbar("Berhasil Ditambahkan", "is-success");
          })
          .catch((error) => {
            this.errors = error;
            this.isLoading = false;
            console.log(this.errors);
            if (this.errors.message == "Request failed status code 400") {
              this.snackbar("Gagal Ditambahkan", "is-danger");
            } else {
              this.snackbar(
                "Ada Inputan Salah.Silahkan coba lagi",
                "is-danger"
              );
            }
          });
      }
      // this.isLoading = false
      //console.log(this.form.tgl_lahir.value)
    },
    editData(editID) {
      this.isLoading = true;
      if (this.checkDataUbah() == false) {
        this.snackbar("Gagal Diedit", "is-danger");
        this.isLoading = false;
      } else {
        this.editDataGuru.nuptk = this.form.nuptk.value;
        this.editDataGuru.nama_guru = this.form.nama_guru.value;
        this.editDataGuru.jenis_kelamin = this.form.jenis_kelamin.value;
        if (this.form.tgl_lahir.value !== "") {
          this.editDataGuru.tgl_lahir = this.convertTgl(
            this.form.tgl_lahir.value
          );
        } else {
          this.editDataGuru.tgl_lahir = this.form.tgl_lahir.value;
        }
        this.editDataGuru.no_handphone = this.form.no_handphone.value;
        this.editDataGuru.email = this.form.email.value;
        this.editDataGuru.jenis_paket = this.form.jenis_paket.value;
        this.editDataGuru.mata_pelajaran = this.form.mata_pelajaran.value;
        this.editDataGuru.jenis_guru = this.form.jenis_guru.value;
        this.editDataGuru.id_sekolah = this.form.nama_sekolah.value;
        this.editDataGuru.id_regu = this.form.nama_regu.value;
        this.editDataGuru.nomor_paket = this.form.nomor_paket.value;
        this.editDataGuru.nomor_urut = this.form.nomor_urut.value;
        this.editDataGuru.jabatan = this.form.jabatan.value;

        console.log(editID);
        console.log(this.editDataGuru);

        var uri = this.$apiUrl + "guru/" + editID;
        this.$http
          .post(uri, this.editDataGuru, this.config)
          .then((response) => {
            this.isLoading = false;
            this.$router.push({ name: "BerandaGuru" });
            this.snackbarMessage = response.data.message;
            this.snackbar("Data Berhasil Diedit", "is-success");
          })
          .catch((error) => {
            this.errors = error;
            this.isLoading = false;
            console.log(this.errors);
            if (this.errors.message == "Request failed status code 400") {
              this.snackbar("Gagal Diedit", "is-danger");
            } else {
              this.snackbar(
                "Ada Inputan Salah.Silahkan coba lagi",
                "is-danger"
              );
            }
          });
      }
      // this.isLoading = false
    },
    confirm() {
      this.editID == 0 ? this.tambahData() : this.editData(this.editID);
    },
    snackbar(snackbarMessage, type) {
      this.$buefy.toast.open({
        duration: 5000,
        message: snackbarMessage,
        //type: type,
        type: type,
        position: "is-top",
        actionText: "OK",
        queue: false,
      });
    },
  },
  mounted() {
    if (this.$session.exists()) {
      this.config = {
        headers: {
          Authorization: "Bearer " + this.$session.get("token"),
        },
      };
    }
    this.activeBiro = this.$session.get("biro");
    if (this.activeBiro) {
      this.detailId = this.activeBiro.id_biro;
      this.getSekolahByBiro();
      // this.getDataByBiro(this.detailId)
    }

    this.getRegu();
    if (this.$route.params.id) {
      this.editID = this.$route.params.id;
      this.actionTitle = "Ubah";
      // console.log(this.editID)
      this.getData(this.editID);
    } else {
      this.actionTitle = "Tambah";
    }
    // this.isLoading=false
  },
};
</script>